{
  "login": {
    "title": "Connexion",
    "emailLabel": "Adresse e-mail",
    "passwordLabel": "Mot de passe",
    "rememberMe": "Se souvenir de moi pendant 30 jours",
    "submitButton": "Se connecter",
    "submittingButton": "Connexion en cours...",
    "forgotPassword": "Mot de passe oublié ?",
    "setNewPassword": "Définir un nouveau mot de passe ici",
    "sessionExpired": "Session expirée",
    "noAccountYet": "Pas encore de compte ?",
    "createOne": "Créez-en un"
  },
  "forgotPassword": {
    "title": "Mot de passe oublié",
    "emailLabel": "Adresse e-mail",
    "submitButton": "Envoyer le lien de réinitialisation par e-mail",
    "backToLogin": "Retour à la connexion",
    "submittingButton": "Envoi en cours...",
    "successTitle": "Vérifiez votre boîte de réception",
    "successMessage": "Si un compte existe pour cette adresse, nous avons envoyé un lien de réinitialisation par e-mail."
  },
  "confirmEmail": {
    "confirming": "Confirmation de votre e-mail…",
    "successTitle": "E-mail confirmé",
    "successMessage": "Votre adresse e-mail a été confirmée. Vous pouvez maintenant vous connecter à votre compte.",
    "continueToLogin": "Continuer vers la connexion",
    "errorTitle": "Échec de la confirmation",
    "errorMessage": "Nous n'avons pas pu confirmer votre e-mail. Le lien est peut-être invalide ou expiré."
  },
  "resetPassword": {
    "title": "Réinitialiser le mot de passe",
    "subtitle": "Saisissez votre nouveau mot de passe ci-dessous",
    "newPasswordLabel": "Nouveau mot de passe",
    "newPasswordPlaceholder": "Saisissez votre nouveau mot de passe",
    "confirmPasswordLabel": "Confirmer le nouveau mot de passe",
    "confirmPasswordPlaceholder": "Confirmez votre nouveau mot de passe",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "submitButton": "Définir le nouveau mot de passe",
    "submittingButton": "Réinitialisation en cours...",
    "invalidToken": "Jeton de réinitialisation invalide",
    "fixRequirements": "Veuillez corriger les exigences du mot de passe",
    "failedReset": "Échec de la réinitialisation du mot de passe"
  },
  "acceptTerms": {
    "title": "Conditions générales d'utilisation",
    "subtitle": "Veuillez lire et accepter nos conditions pour continuer",
    "welcomeTitle": "Bienvenue sur Flipping Pal !",
    "welcomeBody": "Ces conditions générales définissent les règles et réglementations pour l'utilisation du site Web de Flipping Pal, situé à",
    "welcomeBody2": "En accédant à ce site Web, vous acceptez ces conditions générales. Ne continuez pas à utiliser Flipping Pal si vous n'acceptez pas toutes les conditions générales énoncées sur cette page.",
    "keyPointsTitle": "Points clés :",
    "keyPoints": {
      "0": "Flipping Pal détient tous les droits de propriété intellectuelle sur les contenus de ce site Web",
      "1": "Vous ne pouvez pas republier, vendre ou redistribuer le contenu de Flipping Pal",
      "2": "Nous utilisons des cookies pour améliorer votre expérience sur notre site Web",
      "3": "Les commentaires des utilisateurs ne reflètent pas les opinions de Flipping Pal",
      "4": "Nous nous réservons le droit de modifier ces conditions à tout moment",
      "5": "Le contenu du site Web est fourni \"tel quel\" sans garanties"
    },
    "responsibilitiesTitle": "Vos responsabilités :",
    "responsibilities": {
      "0": "Utiliser le service conformément à toutes les lois applicables",
      "1": "Maintenir la sécurité des identifiants de votre compte",
      "2": "Ne pas tenter de compromettre la sécurité de nos systèmes",
      "3": "Respecter les droits de propriété intellectuelle"
    },
    "previewNote": "📄 Ceci est un aperçu de nos Conditions générales d'utilisation. Cliquez sur \"Voir les conditions complètes\" ci-dessous pour lire le document complet.",
    "viewFullTerms": "Voir les conditions générales complètes (s'ouvre dans un nouvel onglet)",
    "checkboxLabel": "J'ai lu et j'accepte les conditions générales d'utilisation",
    "checkboxDescription": "En cochant cette case, vous reconnaissez avoir lu, compris et accepté d'être engagé par ces conditions.",
    "acceptButton": "Accepter et continuer",
    "acceptingButton": "Acceptation...",
    "questionsText": "Des questions sur nos conditions ?",
    "contactSupport": "Contacter le support"
  },
  "discord": {
    "linkingTitle": "Liaison du compte Discord",
    "linkingBody": "Veuillez patienter pendant que nous connectons votre compte Discord...",
    "successTitle": "Succès !",
    "successBody": "Votre compte Discord a été lié avec succès.",
    "successWindowClose": "Cette fenêtre se fermera automatiquement...",
    "successRedirect": "Vous allez être redirigé vers les paramètres...",
    "errorTitle": "Échec de la liaison",
    "errorBody": "Nous n'avons pas pu lier votre compte Discord.",
    "errorWindowClose": "Cette fenêtre se fermera automatiquement...",
    "errorRedirect": "Vous allez être redirigé vers les paramètres...",
    "backToSettings": "Retour aux paramètres"
  },
  "register": {
    "title": "Créer un compte",
    "subtitle": "Rejoins-nous et commence ton aventure aujourd'hui",
    "emailLabel": "Adresse e-mail",
    "emailPlaceholder": "Saisir ton adresse e-mail",
    "passwordLabel": "Mot de passe",
    "passwordPlaceholder": "Créer un mot de passe sécurisé",
    "confirmPasswordLabel": "Confirmer le mot de passe",
    "confirmPasswordPlaceholder": "Confirmer ton mot de passe",
    "passwordStrength": "Force du mot de passe",
    "strengthStrong": "Fort",
    "strengthMedium": "Moyen",
    "strengthWeak": "Faible",
    "termsLabel": "J'accepte les",
    "termsLink": "Conditions générales d'utilisation",
    "termsLabel2": "",
    "submitButton": "Créer un compte",
    "submittingButton": "Création du compte...",
    "alreadyHaveAccount": "Tu as déjà un compte ?",
    "signInHere": "Se connecter ici",
    "registrationClosed": "Inscription actuellement impossible",
    "registrationClosedMessage": "Pour le moment, les inscriptions sont fermées",
    "fixFormErrors": "Corrige les erreurs du formulaire avant de soumettre",
    "acceptTermsRequired": "Accepte les conditions générales pour continuer",
    "registrationFailed": "L'inscription a échoué. Veuillez réessayer."
  },
  "errorBoundary": {
    "title": "Quelque chose s'est mal passé",
    "subtitle": "Une erreur inattendue s'est produite. Ne t'inquiète pas — tes données sont en sécurité.",
    "unknownError": "Erreur inconnue",
    "goHome": "Aller à l'accueil",
    "reloadPage": "Recharger la page",
    "logout": "Se déconnecter",
    "showErrorDetails": "Afficher les détails de l'erreur",
    "hideErrorDetails": "Masquer les détails de l'erreur",
    "copyToClipboard": "Copier dans le presse-papiers",
    "copied": "Copié !",
    "copy": "Copier",
    "errorLabel": "Erreur",
    "componentStackLabel": "Pile de composants",
    "reference": "Référence"
  }
}
